/**
 * Starter prompts offered under the homepage's "Ask Panorama" field.
 *
 * The homepage hero is the only place these appear. The assistant widget and
 * the chat's empty state used to carry a subset; they no longer do, so that a
 * user is nudged once on the way in rather than at every step.
 *
 * The mock spells the third one "Preffered"; corrected here.
 */
export const ASSISTANT_PROMPTS: readonly string[] = [
  'What is Panorama?',
  'How do I request an offering?',
  'What does Preferred mean?',
  'Which offerings are free?',
  'Show all AI/ML tools',
  'How does chargeback work?',
  'What categories are available?',
];

/**
 * Gates the two things that turn an answer into a next step: the suggested
 * follow-up questions, and the offering links inside the answer text.
 *
 * One flag for both because they are one feature. The chips are template
 * structure and the links are produced inside the markdown render, so it is read
 * both by `*inexpFeatureFlag` and in code — gate only one and half the feature
 * stays permanently on.
 *
 * It does NOT gate the copy/regenerate row, which ships unconditionally, nor the
 * factsheet download, which has a flag of its own.
 *
 * Keeps its `2619` name. Renaming it means an Unleash change in three
 * environments for nothing a user would see.
 */
export const ASSISTANT_ACTIONS_FLAG = 'panorama_inexp_2619_assistant_actions';
